import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export default function CopyButton({ text, isDark, label = 'Copy', variant = 'default' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API unavailable; fail silently
    }
  };

  const base =
    'inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-all duration-fast active:scale-95';

  const solid = isDark
    ? 'bg-white text-background-dark hover:bg-gray-200'
    : 'bg-text text-white hover:bg-text/90';

  const ghost = isDark
    ? 'bg-border-dark text-gray-300 hover:text-white'
    : 'bg-background-sidebar text-text-muted hover:text-text';

  const copiedStyle = isDark
    ? 'bg-green-900/30 text-green-400'
    : 'bg-green-50 text-green-700';

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`${base} ${copied ? copiedStyle : variant === 'solid' ? solid : ghost}`}
    >
      {copied ? <Check size={13} /> : <Copy size={13} />}
      {copied ? 'Copied' : label}
    </button>
  );
}
